import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { N700 } from '@atlaskit/theme/colors';

import { useSearchParameters } from '@/components/signup/hooks/use-search-parameters';
import { ServiceCollectionLogo } from '@/components/signup/utils/logos/service-collection-logo';
import { ProductKey } from '@/components/signup/utils/products';
import { Logo } from '@/libraries/wpl/foundations/src/logo';

const headerStyle = css({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
});

const h1Style = css({
	fontSize: '2rem',
	fontWeight: '500',
	color: N700,
	marginBlockStart: '28px',
	marginBlockEnd: '24px',
	letterSpacing: '-0.008em',
	lineHeight: '40px',
});

export const Header = /* istanbul ignore next */ () => {
	const intl = useIntl();
	const { products } = useSearchParameters();
	const product = products.length === 1 ? products[0] : '';

	const headerMessage = {
		identifier: 'confirmation.header',
		text: intl.formatMessage({
			id: 'confirmation.header.text',
			defaultMessage: "We're building your site ...",
		}),
	};
	const bitbucketHeadingMessage = {
		identifier: 'confirmation.bitbucket.header',
		text: intl.formatMessage({
			id: 'confirmation.bitbucket.header.text',
			defaultMessage: 'One moment, your product is starting up',
		}),
	};
	const loomHeadingMessage = {
		identifier: 'confirmation.loom.header',
		text: intl.formatMessage({
			id: 'confirmation.loom.header.text',
			defaultMessage: 'We’re setting you up on Loom',
		}),
	};

	const serviceCollectionHeadingMessage = {
		identifier: 'confirmation.serviceCollection.header',
		text: intl.formatMessage({
			id: 'confirmation.serviceCollection.header.text',
			defaultMessage: 'Creating your site...',
		}),
	};

	const getHeadingMessage = (product: string | undefined) => {
		switch (product) {
			case ProductKey.BITBUCKET:
				return bitbucketHeadingMessage;
			case ProductKey.LOOM:
				return loomHeadingMessage;
			case ProductKey.SERVICE_COLLECTION:
				return serviceCollectionHeadingMessage;
			default:
				return headerMessage;
		}
	};

	const getHeaderLogo = (product: string | undefined) => {
		switch (product) {
			case ProductKey.SERVICE_COLLECTION:
				return <ServiceCollectionLogo />;
			default:
				return <Logo type={'logo'} appearance={'brand'} brand={'atlassian'} />;
		}
	};

	return (
		<section css={headerStyle}>
			{getHeaderLogo(product)}
			<h1 css={h1Style}>{getHeadingMessage(product).text}</h1>
		</section>
	);
};

export default Header;
